import { render, staticRenderFns } from "./inbound-dispatch-list.vue?vue&type=template&id=cd5e3f58"
import script from "./inbound-dispatch-list.vue?vue&type=script&lang=ts"
export * from "./inbound-dispatch-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd5e3f58')) {
      api.createRecord('cd5e3f58', component.options)
    } else {
      api.reload('cd5e3f58', component.options)
    }
    module.hot.accept("./inbound-dispatch-list.vue?vue&type=template&id=cd5e3f58", function () {
      api.rerender('cd5e3f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/inbound-dispatch-list.vue"
export default component.exports